import type { ChatMessageData } from "../types";

/**
 * 前回取得で既読だったメッセージの read_time を引き継ぐ（既読→未読に戻さない）。
 * BE の chat はタスクごとに既読位置をキャッシュしており、ポーリングの振り分け先次第で read_time が null に戻るため。
 */
export const keepReadTime = (
  previous: ChatMessageData[] | undefined,
  next: ChatMessageData[],
): ChatMessageData[] => {
  if (!previous || previous.length === 0) return next;
  const readTimes = new Map<string, string>();
  for (const message of previous) {
    if (message.read_time) readTimes.set(message.msg_id, message.read_time);
  }
  return next.map((message) => {
    if (message.read_time) return message;
    const readTime = readTimes.get(message.msg_id);
    return readTime ? { ...message, read_time: readTime } : message;
  });
};
